import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import Theme from "./Theme";
import { formatDate } from "./Utils";

const formatCurrency = (cents) => {
  const dollar = cents / 100;
  if (dollar % 1 === 0) {
    return Math.floor(dollar).toString();
  } else {
    if (dollar.toFixed(1) % 1 === 0)
      return Math.floor(dollar.toFixed(1)).toString();
    else return dollar.toFixed(1);
  }
};
const PolicyResponse = ({ policy }) => {
  return (
    <Box>
      <br />
      <Table className="border">
        <TableHead>
          <TableRow
            className="bg-table-head"
            sx={{ backgroundColor: "#f2f2f2" }}
          >
            <TableCell className="font-bold p-6">Policy</TableCell>
            <TableCell className="font-bold p-6">Number</TableCell>
            <TableCell className="font-bold p-6">Premium</TableCell>
            <TableCell className="font-bold p-6" colSpan={2}>
              Effective Dates
            </TableCell>
            {policy?.vehicles?.length <= 0 ? (
              <TableCell className="font-bold p-6"> Status</TableCell>
            ) : (
              <TableCell className="font-bold p-6"></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{
              bgcolor:
                policy.vehicles.length <= 0
                  ? policy?.status === "ACTIVE"
                    ? "#ecfff5"
                    : "#ffe9ec"
                  : null,
            }}
          >
            <TableCell className="p-6">{policy.policy_type}</TableCell>
            <TableCell className="p-6">
              {policy.carrier_policy_number}
            </TableCell>
            <TableCell className="p-6">
              $ {formatCurrency(policy.total_premium_cents)}
            </TableCell>
            <TableCell className="p-6" colSpan={2}>
              {policy?.description
                ? policy?.description?.substr(
                    policy?.description?.indexOf(" ") + 1
                  )
                : "N/A"}
            </TableCell>
            {policy?.vehicles?.length <= 0 ? (
              <TableCell
                className="p-6 font-bold"
                colSpan={6}
                sx={{
                  color:
                    policy?.status === "ACTIVE"
                      ? Theme.palette.primary.main
                      : Theme.palette.error.main,
                  // textAlign: "center",
                }}
              >
                {policy.status}
                {policy.canceled_date
                  ? ` - ${formatDate(policy?.canceled_date)}`
                  : ""}
              </TableCell>
            ) : (
              <TableCell className="p-6 font-bold"></TableCell>
            )}
          </TableRow>

          {/* {console.log("auto.vehicles", vehicles)} */}
          {policy?.vehicles?.length > 0 &&
            policy?.vehicles?.map((vehicle) => {
              return (
                <>
                  {vehicle?.year && (
                    <TableRow
                      sx={{
                        bgcolor:
                          policy?.status === "ACTIVE" ? "#ecfff5" : "#ffe9ec",
                      }}
                    >
                      <TableCell className="p-6 font-bold" colSpan={4}>
                        {vehicle?.year +
                          " " +
                          vehicle?.make +
                          " " +
                          vehicle?.model}
                      </TableCell>
                      <TableCell
                        className="p-6 font-bold"
                        colSpan={2}
                        sx={{
                          color:
                            policy?.status === "ACTIVE"
                              ? Theme.palette.primary.main
                              : Theme.palette.error.main,
                          textAlign: "center",
                        }}
                      >
                        {policy.status}
                        {policy.canceled_date
                          ? ` - ${formatDate(policy?.canceled_date)}`
                          : ""}
                      </TableCell>
                    </TableRow>
                  )}
                  {vehicle.vin || vehicle?.hin ? (
                    <TableRow
                      className="bg-table-row"
                      sx={{ backgroundColor: "#ffffff" }}
                    >
                      {/* <TableCell className="p-6 font-bold" colSpan={1}>
                        VIN
                      </TableCell> */}
                      <TableCell className="p-6" colSpan={6}>
                        {vehicle?.vin || vehicle?.hin}
                      </TableCell>
                    </TableRow>
                  ) : (
                    "N/A"
                  )}
                  {vehicle.lien_holder && (
                    <>
                      <TableRow>
                        <TableCell className="font-bold p-6" colSpan={1}>
                          Lien Holder
                        </TableCell>
                        <TableCell className="p-6" colSpan={5}>
                          {vehicle.lien_holder || "N/A"}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        className="bg-table-row"
                        sx={{ backgroundColor: "#ffffff" }}
                      >
                        <TableCell className="font-bold p-6" colSpan={1}>
                          Lien Holder Address
                        </TableCell>
                        <TableCell className="p-6" colSpan={5}>
                          {vehicle.lien_holder_address?.full_address || "N/A"}
                        </TableCell>
                      </TableRow>
                    </>
                  )}

                  {vehicle?.coverages?.length > 0 && (
                    <>
                      <TableRow>
                        <TableCell className="font-bold p-6">
                          Coverages
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Person Per Limit
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Per Incident Limit
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Deductible
                        </TableCell>
                        <TableCell className="font-bold p-6">Premium</TableCell>
                        <TableCell className="font-bold p-6">
                          Declined
                        </TableCell>
                      </TableRow>

                      {vehicle?.coverages.map((coverage) => (
                        <TableRow
                          className="bg-table-row"
                          sx={{
                            backgroundColor:
                              (coverage?.name === "COLLISION" &&
                                formatCurrency(coverage.deductible_cents) >
                                  500) ||
                              (coverage?.name === "COMPREHENSIVE" &&
                                formatCurrency(coverage.deductible_cents) > 500)
                                ? "#ffe9ec"
                                : "#ffffff",
                          }}
                        >
                          <TableCell className="p-6">{coverage.name}</TableCell>
                          <TableCell className="p-6">
                            $ {formatCurrency(coverage.per_person_limit_cents)}
                          </TableCell>
                          <TableCell className="p-6">
                            ${" "}
                            {formatCurrency(coverage.per_incident_limit_cents)}
                          </TableCell>
                          <TableCell
                            className="p-6"
                            sx={{
                              fontWeight:
                                (coverage?.name === "COLLISION" &&
                                  formatCurrency(coverage.deductible_cents) >
                                    500) ||
                                (coverage?.name === "COMPREHENSIVE" &&
                                  formatCurrency(coverage.deductible_cents) >
                                    500)
                                  ? "bold"
                                  : null,
                              color:
                                (coverage?.name === "COLLISION" &&
                                  formatCurrency(coverage.deductible_cents) >
                                    500) ||
                                (coverage?.name === "COMPREHENSIVE" &&
                                  formatCurrency(coverage.deductible_cents) >
                                    500)
                                  ? Theme.palette.error.main
                                  : (coverage?.name === "COLLISION" &&
                                      formatCurrency(
                                        coverage.deductible_cents
                                      ) <= 500) ||
                                    (coverage?.name === "COMPREHENSIVE" &&
                                      formatCurrency(
                                        coverage.deductible_cents
                                      ) <= 500)
                                  ? Theme.palette.primary.main
                                  : null,
                            }}
                          >
                            $ {formatCurrency(coverage.deductible_cents)}
                          </TableCell>
                          <TableCell className="p-6">
                            $ {formatCurrency(coverage.premium_cents)}
                          </TableCell>
                          <TableCell className="p-6">
                            {coverage.is_declined.toString().toUpperCase()}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}
                </>
              );
            })}
          {policy?.dwellings?.length > 0 &&
            policy?.dwellings.map((dwelling) => {
              return (
                <>
                  <TableRow>
                    <TableCell className="p-6" colSpan={6}>
                      {dwelling?.address?.address_nature}
                    </TableCell>
                  </TableRow>
                  <TableRow
                    className="bg-table-row"
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <TableCell className="p-6" colSpan={6}>
                      {dwelling?.address?.full_address}
                    </TableCell>
                  </TableRow>
                  {dwelling?.coverages.length > 0 && (
                    <>
                      <TableRow>
                        <TableCell className="font-bold p-6">
                          Coverages
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Person Per Limit
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Per Incident Limit
                        </TableCell>
                        <TableCell className="font-bold p-6">
                          Deductible
                        </TableCell>
                        <TableCell className="font-bold p-6">Premium</TableCell>
                        <TableCell className="font-bold p-6">
                          Declined
                        </TableCell>
                      </TableRow>
                      {dwelling.coverages.map((coverages) => {
                        return (
                          <>
                            <TableRow
                              className="bg-table-row"
                              sx={{ backgroundColor: "#ffffff" }}
                            >
                              <TableCell className="p-6">
                                {coverages.friendly_name}
                              </TableCell>
                              <TableCell className="p-6">
                                $ {coverages.per_person_limit_cents / 100}
                              </TableCell>
                              <TableCell className="p-6">
                                $ {coverages.per_incident_limit_cents / 100}
                              </TableCell>
                              <TableCell className="p-6">
                                $ {formatCurrency(coverages.deductible_cents)}
                              </TableCell>
                              <TableCell className="p-6">
                                $ {formatCurrency(coverages.premium_cents)}
                              </TableCell>
                              <TableCell className="p-6">
                                {coverages.is_declined.toString().toUpperCase()}
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                    </>
                  )}
                </>
              );
            })}
        </TableBody>
      </Table>
    </Box>
  );
};
export default PolicyResponse;
